module.exports = __webpack_public_path__ + "static/media/ticket.00eb4723.png";